import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ApprovalList = withAsync({
	loader: lazyForPaint(() => import(/* webpackChunkName: "approval-list" */ './approval-list')),
});
